import { gql } from '__generated__';

export default gql(`
  mutation ToggleCoupon($input: EditCouponInput!) {
    editCoupon(input: $input) {
      id
      active
    }
  }
`);
